// eslint-disable-next-line no-restricted-imports
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

export const Dialog = Object.assign(MuiDialog, {
  Actions: DialogActions,
  Content: DialogContent,
  Title: DialogTitle,
});
